import React from "react";

export const usePaginatedData = <T>({
  data,
  maxPageSize = 10,
}: {
  data?: Array<T>;
  maxPageSize?: number;
}) => {
  const [activePageNumber, setActivePageNumber] = React.useState(1);
  const dataLength = (data?.[0] !== undefined && data?.length) || 0;
  const maxPageNumber = Math.ceil(dataLength / maxPageSize);
  const startIndex = maxPageSize * (activePageNumber - 1);
  const paginatedData = (data ?? []).slice(
    startIndex,
    startIndex + maxPageSize
  );

  return {
    paginatedData,
    maxPageNumber,
    activePageNumber,
    setActivePageNumber,
  };
};
